import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card, Table } from '../../onestep-library/BaseUI'
import moment from 'moment'
import PaidInvoiceListing from './components/PaidInvoiceListing'
import { fetchPaidInvoices } from './actions'

function PaidInvoices(props){
  const dispatch = useDispatch()
  const { paidInvoices, ui } = useSelector(state=>state.paidInvoices)
  const { organization, resident } = useSelector(state => state);
  const { loading } = ui


  useEffect(()=>{
    dispatch(fetchPaidInvoices())
  },[])

  function handleExportCsv(){
    window.open(`/organizations/${organization.name}/invoices/export_csv?by_resident=${resident.id}`, '_blank');
  }

  return(
    <div>
      <Card
        visible={paidInvoices.length > 0 || true}
        title="Paid"
        isLoading={loading}
        headerButtons={[{label: 'Export CSV', handleClick: ()=> handleExportCsv()}]}
        className="mt-4">
        <Table
          columnNames={[`Paid On`, "Due On", "Memo", "Amount Paid", ""]}
          rows={paidInvoices}
          Row={PaidInvoiceListing}
          zeroCaseMessage="No Paid Invoices"/>
      </Card>
    </div>
  )
}

export default PaidInvoices